import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhatWeOffer from "../../components/WhatWeOffer/WhatWeOffer";
import OurApproach from "../../components/OurApproach/OurApproach";
import ServicesHighlight from "../../components/ServicesHighlight/ServicesHighlight";
import CmsRenderer from "../../components/CmsRenderer/CmsRenderer";
import cmsClient from "../../lib/cmsClient";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./Services.css";

export default function Services() {
  useScrollReveal();
  const [cmsPage, setCmsPage] = React.useState({ blocks: [], theme: {} });

  React.useEffect(() => {
    (async () => {
      try {
        const j = await cmsClient.getPage('services');
        if (j?.success) setCmsPage(j.data || { blocks: [], theme: {} });
      } catch (_e) {}
    })();
  }, []);

  const hasBlocks = (cmsPage.blocks || []).length > 0;

  return (
    <div>
      <Helmet>
        <title>Nos services — NEXUS SOLUTIONS</title>
        <meta name="description" content="Sites web, applications mobiles et e-commerce pour les PME ivoiriennes. Prix en FCFA, Orange Money et Wave integres, livraison rapide depuis Abidjan." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Services NEXUS SOLUTIONS",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "Service", "name": "Création de site web", "description": "Sites vitrines et landing pages professionnels livrés en 7 jours.", "provider": { "@type": "Organization", "name": "NEXUS SOLUTIONS" }, "areaServed": "Côte d'Ivoire", "offers": { "@type": "Offer", "priceCurrency": "XOF", "price": "150000" } } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "Service", "name": "Application mobile", "description": "Applications iOS et Android avec React Native.", "provider": { "@type": "Organization", "name": "NEXUS SOLUTIONS" }, "areaServed": "Côte d'Ivoire", "offers": { "@type": "Offer", "priceCurrency": "XOF", "price": "500000" } } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "Service", "name": "E-commerce", "description": "Boutiques en ligne avec Orange Money et Wave intégrés.", "provider": { "@type": "Organization", "name": "NEXUS SOLUTIONS" }, "areaServed": "Côte d'Ivoire", "offers": { "@type": "Offer", "priceCurrency": "XOF", "price": "300000" } } }
          ]
        })}</script>
      </Helmet>

      {hasBlocks ? (
        <CmsRenderer blocks={cmsPage.blocks} />
      ) : (
        <>
          <section className="services-hero">
            <div className="services-hero__content">
              <h1 className="services-hero__title" data-reveal="">
                Des solutions digitales<br />
                <span>pensees pour la Cote d'Ivoire</span>
              </h1>
              <p className="services-hero__subtitle" data-reveal="" data-delay="80">
                Sites web, apps mobiles, e-commerce — livres vite, au bon prix,
                avec un interlocuteur local que vous pouvez appeler.
              </p>
              <div className="services-hero__stats" data-reveal="" data-delay="160">
                <div className="services-hero__stat">
                  <span className="services-hero__stat-num">15+</span>
                  <span className="services-hero__stat-label">projets livres</span>
                </div>
                <div className="services-hero__stat-sep" />
                <div className="services-hero__stat">
                  <span className="services-hero__stat-num">24h</span>
                  <span className="services-hero__stat-label">de reponse garantie</span>
                </div>
                <div className="services-hero__stat-sep" />
                <div className="services-hero__stat">
                  <span className="services-hero__stat-num">100%</span>
                  <span className="services-hero__stat-label">satisfaction client</span>
                </div>
                <div className="services-hero__stat-sep" />
                <div className="services-hero__stat">
                  <span className="services-hero__stat-num">FCFA</span>
                  <span className="services-hero__stat-label">prix transparents</span>
                </div>
              </div>
              <Link to="/devis" className="services-hero__cta" data-reveal="" data-delay="240">
                Obtenir un devis gratuit
              </Link>
              <div className="services-trust-bar" data-reveal="" data-delay="320">
                <span>✓ Orange Money & Wave</span>
                <span>✓ Paiement en tranches</span>
                <span>✓ Devis gratuit</span>
                <span>✓ Base a Abidjan</span>
              </div>
            </div>
          </section>

          <WhatWeOffer />
          <ServicesHighlight />
          <OurApproach />

          <section className="services-final-cta">
            <h2>Vous savez ce qu'il vous faut ?</h2>
            <p>
              Repondez a 4 questions rapides et obtenez une estimation de prix immediate.
            </p>
            <Link to="/devis" className="services-final-cta__btn">
              Demarrer mon devis gratuit
            </Link>
          </section>
        </>
      )}
    </div>
  );
}
